/**
 * Thin wrapper around GA4 gtag for SPA route changes and conversion events.
 * `send_page_view` is OFF in index.html so we fire it ourselves on every
 * react-router navigation.
 */
const GA_ID = "G-16MW3QPX1H";

const isGtagReady = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

export function pageview(path) {
  if (!isGtagReady()) return;
  window.gtag("event", "page_view", {
    page_path: path || (typeof window !== "undefined" ? window.location.pathname + window.location.search : "/"),
    page_location: typeof window !== "undefined" ? window.location.href : "",
    page_title: typeof document !== "undefined" ? document.title : "",
    send_to: GA_ID,
  });
}

export function track(event, params = {}) {
  if (!isGtagReady()) return;
  try {
    window.gtag("event", event, { ...params, send_to: GA_ID });
  } catch (e) {
    // never break the app for analytics
    // eslint-disable-next-line no-console
    console.debug("gtag error", e);
  }
}

// ---- Named helpers for each tracked conversion --------------------------
export const trackViewItem = (product, price) =>
  track("view_item", {
    currency: "GBP",
    value: Number(price || product?.price || 0),
    items: [
      {
        item_id: product?.id,
        item_name: product?.name,
        item_category: product?.category,
        price: Number(price || product?.price || 0),
        quantity: 1,
      },
    ],
  });

export const trackBeginCheckout = ({ kind, item_id, item_name, price, quantity = 1, category }) =>
  track("begin_checkout", {
    currency: "GBP",
    value: Number(price || 0) * (quantity || 1),
    items: [
      {
        item_id,
        item_name,
        item_category: category || kind,
        price: Number(price || 0),
        quantity,
      },
    ],
  });

export const trackPurchase = ({ session_id, amount, kind, label }) =>
  track("purchase", {
    transaction_id: session_id,
    currency: "GBP",
    value: Number(amount || 0),
    items: [
      {
        item_id: session_id,
        item_name: label || kind,
        item_category: kind,
        price: Number(amount || 0),
        quantity: 1,
      },
    ],
  });

export const trackSignUp = (method = "email") => track("sign_up", { method });

export const trackLogin = (method = "email") => track("login", { method });

export const trackGenerateLead = (source = "support") =>
  track("generate_lead", { source });
